type PendingCall = {
  resolve: (value: unknown) => void;
  reject: (error: unknown) => void;
};

const pending = new Map<string, PendingCall>();

let seq = 0;
const nextId = () => `fc-${Date.now()}-${seq++}`;

export const registerFormCall = (): {
  callId: string;
  promise: Promise<unknown>;
} => {
  const callId = nextId();
  const promise = new Promise<unknown>((resolve, reject) => {
    pending.set(callId, { resolve, reject });
  });
  return { callId, promise };
};

export const resolveFormCall = (
  callId: string | undefined,
  value: unknown
): void => {
  if (!callId) return;
  const d = pending.get(callId);
  if (!d) return;
  pending.delete(callId);
  d.resolve(value);
};

export const rejectFormCall = (
  callId: string | undefined,
  error: unknown
): void => {
  if (!callId) return;
  const d = pending.get(callId);
  if (!d) return;
  pending.delete(callId);
  d.reject(error);
};
